'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ROUTES } from '@/constants';
interface LoginPromptModalProps {
  opened: boolean;
  onClose: () => void;
  description: string;
}
export const LoginPromptModal = t0 => {
  const $ = _c(19);
  const {
    opened,
    onClose,
    description
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="font-700 text-Gray-900 typo-body2">로그인이 필요해요</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== description) {
    t2 = <p className="text-center font-400 text-Gray-700 typo-body2">{description}</p>;
    $[1] = description;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClose) {
    t3 = <Button className="flex-1" theme="sub-fill" onClick={onClose}>닫기</Button>;
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== pathname) {
    t4 = ROUTES.LOGIN.withSearchParams({
      searchParams: {
        redirect: pathname ?? ""
      }
    });
    $[5] = pathname;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Button asChild={true} className="flex-1"><Link href={t4}>로그인</Link></Button>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="flex gap-8 pt-12">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <div className="flex flex-col gap-8">{t1}{t2}{t6}</div>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onClose || $[16] !== opened || $[17] !== t7) {
    t8 = <Modal opened={opened} onClose={onClose}>{t7}</Modal>;
    $[15] = onClose;
    $[16] = opened;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};